import {Day} from "../core/Day";
import {Option} from "../core/Option";

export interface IBoard {

    id: number;
    title: string;
    data: IBoardData[]
    availableOptions: Option[]

}

export interface IBoardData {
    year: number;
    days: Map<number, Day|null>;
}

export function serializeBoard(board: IBoard): string{

    const data = board.data.map((yearData) => {

        return {
            year: yearData.year,
            days: Array.from(yearData.days).map((boardDay) => {
                return {
                    dayNumber: boardDay[0],
                    day: boardDay[1]?.serialize(),
                }
            })
        }

    })

    return JSON.stringify({

        id: board.id,
        title: board.title,
        data: data,
        availableOptions: board.availableOptions.map((availableOption) => availableOption.serialize())

    });

}

export function parseBoard(boardString: string): IBoard{

    const board: any = JSON.parse(boardString);

    console.log(board);

    board.data = board.data.map((yearData: { days: any[], year: number }, index: number) => {
        const days = new Map<number, Day|null>;
        yearData.days.map((day: any) => {

            if(day.day != null)
            {
                days.set(day.dayNumber, Day.parse(day.day))
            }

        });

        return {
            year: yearData.year,
            days: days
        };
    });



    return {

        id: board.id,
        title: board.title,
        data: board.data,
        availableOptions: board.availableOptions.map((availableOption: any) => Option.parse(availableOption))

    }

}